import React from 'react';
import {
  Typography,
  Button,
  Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Skeleton from '@material-ui/lab/Skeleton';
import QuotaAssignmentRow from './QuotaAssignmentRow';

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textTransform: 'none',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(68, 114, 196, 0.08)',
    },
  },
}));

const QuotaAssignmentSection = ({
  assignments,
  onQuotaChange,
  onRemoveQuota,
  onAddPreviousQuarter,
  onAddNextQuarter,
  canAddPreviousQuarter,
  canAddNextQuarter,
  allAvailableQuarters,
  isLoadingQuarters,
  isSaving,
  currencySymbol,
  hideRampStatus = false,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <Typography variant="h6" className={classes.sectionTitle}>
        Quota Assignments
      </Typography>

      {isLoadingQuarters ? (
        <>
          <Skeleton variant="rect" height={50} style={{ marginBottom: '1rem', borderRadius: '4px' }} />
          <Skeleton variant="rect" height={80} style={{ marginBottom: '1rem', borderRadius: '4px' }} />
          <Skeleton variant="rect" height={80} style={{ marginBottom: '1rem', borderRadius: '4px' }} />
          <Skeleton variant="rect" height={80} style={{ marginBottom: '1rem', borderRadius: '4px' }} />
          <Skeleton variant="rect" height={50} style={{ marginBottom: '1rem', borderRadius: '4px' }} />
        </>
      ) : (
        <>
          <Button
            fullWidth
            className={classes.addButton}
            onClick={onAddPreviousQuarter}
            startIcon={<AddIcon />}
            disabled={!canAddPreviousQuarter || isSaving}
          >
            Add Previous Quarter
          </Button>

          {assignments.map((assignment) => (
            <QuotaAssignmentRow
              key={assignment.id}
              assignment={assignment}
              onQuotaChange={onQuotaChange}
              onRemove={onRemoveQuota}
              allAvailableQuarters={allAvailableQuarters}
              isSaving={isSaving}
              currencySymbol={currencySymbol}
              hideRampStatus={hideRampStatus}
              assignmentsLength={assignments.length}
            />
          ))}

          <Button
            fullWidth
            className={classes.addButton}
            onClick={onAddNextQuarter}
            startIcon={<AddIcon />}
            disabled={!canAddNextQuarter || isSaving}
          >
            Add Next Quarter
          </Button>
        </>
      )}
    </div>
  );
};

export default QuotaAssignmentSection;
